<template>
  <IconLucideMinimize />
</template>
